import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import variables from '../../../../../../utils/variables';
import { showCollectionConfirmDialog } from '../../../../../../actions/createAssets/mintNft';
import CircularProgress from '../../../../../../components/CircularProgress';
import { connect } from 'react-redux';
import CollectionSymbolTextField from './CollectionSymbolTextField';
import CollectionNameTextField from './CollectionNameTextField';
import './index.css';
import DescriptionTextField from './DescriptionTextField';
import JsonSchemaTextField from './JsonSchemaTextField';
import { Button } from '@material-ui/core';
import Upload from './Upload';
import CollectionImageUrlTextField from './CollectionImageUrlTextField';
import CollectionConfirmDialog from './CollectionConfirmDialog';
import withRouter from '../../../../../../components/WithRouter';
import { fetchParams } from '../../../../../../actions/params';
import { config } from '../../../../../../config';
import { showInsufficientDialog } from '../../../../../../actions/alertDialog';
import InSufficientDialog from '../../../../../InSufficientDialog';
import SplitInfoSwitch from '../../../../../CreateCollection/SplitInfoSwitch';
import SplitInfo from '../../../../../CreateCollection/SplitInfo';
import TotalSale from '../../../../../CreateCollection/TotalSale';
import { decodeFromBech32 } from '../../../../../../utils/address';
import { showMessage } from '../../../../../../actions/snackbar';

const Step1 = (props) => {
    const {
        params,
        paramsInProgress,
        fetchParams,
    } = props;

    useEffect(() => {
        if (!paramsInProgress && params && !params.denom_creation_fee) {
            fetchParams();
        }
        // eslint-disable-next-line
    }, []);

    const handleClick = () => {
        let balance = props.balance && props.balance.length && props.balance.find((val) => val.denom === config.COIN_MINIMAL_DENOM);
        balance = balance && balance.amount && balance.amount / (10 ** config.COIN_DECIMALS);

        const fee = props.params && props.params.denom_creation_fee && props.params.denom_creation_fee.amount &&
            Number(props.params.denom_creation_fee.amount) / 10 ** config.COIN_DECIMALS;

        if (balance < fee) {
            props.showInsufficientDialog();
        } else {
            let valid = true;
            let weight = 0;
            if (props.splitInfoStatus) {
                if (props.splitValue && props.splitValue.length) {
                    props.splitValue.map((val) => {
                        weight = weight + Number(val.weight);
                        const obj = {};
                        obj.address = val.address;
                        obj.weight = String(val.weight / 100);
                        if (val.address === '') {
                            valid = false;
                            return null;
                        } else if (val.address !== '') {
                            const validity = val.address && decodeFromBech32(val.address) && (val.address.indexOf(config.PREFIX) > -1);
                            if (!validity && valid) {
                                valid = false;
                            }
                        }

                        return null;
                    });
                }
            }

            if (!valid) {
                props.showMessage(variables[props.lang]['invalid_address'], 'warning');
                return;
            }

            if (weight !== 0 && weight < 100) {
                props.showMessage(variables[props.lang]['collaborators_sum_warning'], 'warning');
                return;
            }

            props.showCollectionConfirmDialog();
        }
    };

    const handleUpdate = () => {
        let valid = true;
        let weight = 0;
        if (props.splitInfoStatus) {
            if (props.splitValue && props.splitValue.length) {
                props.splitValue.map((val) => {
                    weight = weight + Number(val.weight);
                    const obj = {};
                    obj.address = val.address;
                    obj.weight = String(val.weight / 100);
                    if (val.address === '') {
                        valid = false;
                        return null;
                    } else if (val.address !== '') {
                        const validity = val.address && decodeFromBech32(val.address) && (val.address.indexOf(config.PREFIX) > -1);
                        if (!validity && valid) {
                            valid = false;
                        }
                    }

                    return null;
                });
            }
        }

        if (!valid) {
            props.showMessage(variables[props.lang]['invalid_address'], 'warning');
            return;
        }

        if (weight !== 0 && weight < 100) {
            props.showMessage(variables[props.lang]['collaborators_sum_warning'], 'warning');
            return;
        }

        props.showCollectionConfirmDialog();
    };

    const totalSale = {
        tokenPrice: props.tokenPrice,
        tokenValue: props.tokenValue,
        details: props.collection,
        splitInfo: props.splitValue,
    };

    const inProgress = props.inProgress || props.signInProgress || props.broadCastInProgress || props.txHashInProgress;
    const disable = props.symbol === '' || props.value === '' || inProgress || props.description.length > 250;
    let updateDisable = disable || (props.collection &&
        (props.value === props.collection.name &&
            (!props.collection.description ? props.description === '' : props.description === props.collection.description) &&
            (!props.collection.preview_uri ? props.imageUrl === '' : props.imageUrl === props.collection.preview_uri)));

    if (props.collection && props.collection.royalty_receivers && props.collection.royalty_receivers.length) {
        if (!props.splitInfoStatus) {
            updateDisable = false;
        } else if (props.collection.royalty_receivers && props.splitValue &&
            (props.collection.royalty_receivers.length !== props.splitValue.length)) {
            updateDisable = false;
        } else if (props.splitInfoStatus) {
            updateDisable = false;
        }
    } else if (props.collection && props.collection.royalty_receivers && !props.collection.royalty_receivers.length) {
        if (props.splitInfoStatus) {
            updateDisable = false;
        }
    }

    return (
        <div className="collection_content">
            <form
                noValidate
                autoComplete="off">
                {props.router && props.router.params && props.router.params.collectionID
                    ? null
                    : <div className="row">
                        <div className="label_info">
                            <p className="title">
                                {(variables[props.lang]['collection_symbol']).toLowerCase()}
                                <span className="text_required">*</span>
                            </p>
                            <p className="title_info">{variables[props.lang]['collection_symbol_info']}</p>
                        </div>
                        <CollectionSymbolTextField/>
                    </div>}
                <div className="row">
                    <div className="label_info">
                        <p className="title">
                            {(variables[props.lang]['collection_name']).toLowerCase()}
                            <span className="text_required">*</span>
                        </p>
                        <p className="title_info">{variables[props.lang]['collection_name_info']}</p>
                    </div>
                    <CollectionNameTextField/>
                </div>
                <div className="row row_reverse description_section">
                    <div className="label_info">
                        <p className="title">
                            {variables[props.lang]['collection_description']}
                            <span className="text_next">{variables[props.lang]['max_characters']}</span>
                        </p>
                    </div>
                    <DescriptionTextField/>
                </div>
                <div className="row al_flx_start">
                    <div className="label_info" style={{ width: '50%' }}>
                        <p className="title">{variables[props.lang]['collection_avatar']}</p>
                        <p className="title_info">{variables[props.lang]['collection_avatar_info']}</p>
                    </div>
                    <div className="upload_avatar" style={{ width: '50%' }}>
                        <CollectionImageUrlTextField/>
                        <Upload/>
                    </div>
                </div>
                <div className="row split_info">
                    <div className="label_info">
                        <p className="title">{variables[props.lang]['add_collaborators']}</p>
                        <p className="title_info">
                            {variables[props.lang]['share_percentage_of_royalties_text']}
                        </p>
                    </div>
                    <SplitInfoSwitch/>
                </div>
                {props.splitInfoStatus && <SplitInfo/>}
                {props.splitInfoStatus && <TotalSale totalSale={totalSale}/>}
                {props.router && props.router.params && props.router.params.collectionID
                    ? null
                    : <div className="row row_reverse">
                        <JsonSchemaTextField/>
                    </div>}
                {props.router && props.router.params && props.router.params.collectionID
                    ? <Button
                        className="primary_button"
                        disabled={updateDisable}
                        variant="contained"
                        onClick={handleUpdate}>
                        {variables[props.lang]['update_collection']}
                    </Button>
                    : <Button
                        className="primary_button"
                        disabled={disable}
                        variant="contained"
                        onClick={handleClick}>
                        {variables[props.lang]['mint_collection']}
                    </Button>}
            </form>
            {inProgress && <CircularProgress className="full_screen"/>}
            <CollectionConfirmDialog/>
            <InSufficientDialog/>
        </div>
    );
};

Step1.propTypes = {
    balance: PropTypes.array.isRequired,
    broadCastInProgress: PropTypes.bool.isRequired,
    collection: PropTypes.object.isRequired,
    fetchParams: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
    paramsInProgress: PropTypes.bool.isRequired,
    showCollectionConfirmDialog: PropTypes.func.isRequired,
    showInsufficientDialog: PropTypes.func.isRequired,
    showMessage: PropTypes.func.isRequired,
    signInProgress: PropTypes.bool.isRequired,
    splitInfoStatus: PropTypes.bool.isRequired,
    splitValue: PropTypes.array.isRequired,
    symbol: PropTypes.string.isRequired,
    tokenPrice: PropTypes.string.isRequired,
    txHashInProgress: PropTypes.bool.isRequired,
    updateCollection: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,

    description: PropTypes.string,
    imageUrl: PropTypes.any,
    router: PropTypes.shape({
        params: PropTypes.shape({
            collectionID: PropTypes.string,
        }).isRequired,
    }),
    tokenValue: PropTypes.object,
};

const stateToProps = (state) => {
    return {
        balance: state.account.bc.balance.value,
        broadCastInProgress: state.account.bc.broadCast.inProgress,
        inProgress: state.createAssets.nft.newCollection.inProgress,
        lang: state.language,
        signInProgress: state.account.bc.protoBufSign.inProgress,
        symbol: state.createAssets.createCollection.symbol,
        txHashInProgress: state.account.bc.txHash.inProgress,
        value: state.createAssets.createCollection.value,
        description: state.createAssets.createCollection.description,
        imageUrl: state.createAssets.createCollection.imageUrl,
        collection: state.createAssets.nft.singleCollection.value,
        params: state.params.params.value,
        paramsInProgress: state.params.params.inProgress,

        splitValue: state.collection.denomSplitInfo.value,
        splitInfoStatus: state.collection.denomSplitInfo.status,
        tokenValue: state.createAssets.nft.tokenValue.value,
        tokenPrice: state.createAssets.nft.tokenPrice,

        updateCollection: state.createAssets.updateCollection.value,
    };
};

const actionToProps = {
    fetchParams,
    showCollectionConfirmDialog,
    showInsufficientDialog,
    showMessage,
};

export default withRouter(connect(stateToProps, actionToProps)(Step1));
